// extracted by mini-css-extract-plugin
export default {"main":"styles_main__cBfUG","ltr":"styles_ltr__t+BRi","rtl":"styles_rtl__Moq92","media":"styles_media__rx0dM","goal":"styles_goal__AhIFh"};